/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  Fullscreen,
  Loading,
  Modal,
  Redirect,
  TitleBar,
} from "@shopify/app-bridge/actions"
import { isShopifyEmbedded as _isShopifyEmbedded } from "@shopify/app-bridge-utils/utilities/platform"

const urlSearchParams = new URLSearchParams(window.location.search)

window.ManageParams = {
  "auth-token": urlSearchParams.get("auth-token") || "",
  // @ts-ignore
  display_intercom: urlSearchParams.get("display_intercom") || "false",
  from: urlSearchParams.get("from") || "",
}

export function isReturnAdmin() {
  return window.ManageParams.from === "admin"
}

export function isShopifyEmbedded() {
  return !isReturnAdmin() && _isShopifyEmbedded()
}

export function renderDiffByPlatform(
  normalElem: React.ReactNode,
  embedElem?: React.ReactNode,
) {
  return isShopifyEmbedded() ? embedElem : normalElem
}

const AppBridge = {
  dispatchFullscreen(action: Fullscreen.Action) {
    this.fullscreen().dispatch(action)
  },

  dispatchModal(action: Modal.Action) {
    this.modal().dispatch(action)
  },

  dispatchLoading(action: Loading.Action) {
    this.loading().dispatch(action)
  },

  // ////////////////////////////////

  app() {
    return window.ShopifyAppBridge
  },

  exist() {
    return !window.ShopifyAppBridge
  },

  modal() {
    return Modal.create(window.ShopifyAppBridge, {
      id: "app-bridge-default-modal",
      message: "Default modal message",
      title: "Default modal title",
    })
  },

  redirect(): Redirect.Redirect {
    return Redirect.create(window.ShopifyAppBridge)
  },

  titleBar(title?: string) {
    return TitleBar.create(window.ShopifyAppBridge, {
      title: title || "Default title",
    })
  },

  loading() {
    return Loading.create(window.ShopifyAppBridge)
  },

  fullscreen() {
    return Fullscreen.create(window.ShopifyAppBridge)
  },
}

export default AppBridge
